/**
 * 导出其他格式
 */

import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';
import { McpOutputConfig, McpOutputStatus } from '@shared/constants/mcp';
import { SVGPureIcon } from '@/ui';

const McpSummaryOutput = observer((props) => {
  const {
    mcpStore,
    event,
    messageItem,
    onRenew,
    isLastMessage,
    type,
    handleSend,
    isAITyping,
  } = props;

  const {
    chatStore,
  } = mcpStore;

  // if(type != "agentStatus" && type != "convertFinalSummary"){
  if(type != "convertFinalSummary"){
    return null;
  }
  // 不可导出其他格式
  if(Object.keys(McpOutputConfig).every(key => ![McpOutputStatus.could, McpOutputStatus.done].includes(event[key]))){
    return null;
  }
  // 非自己的
  if(!chatStore.isOwner && !HelperCore.IS_LOCAL){
    return null;
  }
  // 工作流 TODO 应该让模型处理
  if(mcpStore.isAgentFlow){
    return null;
  }

  return (
    <div className='mcp-simple-sep'>
      <div className="text-16px leading-22px">
        您还可以将最终结果转换为其他格式：
      </div>
      <div className="flex w-full flex-wrap">
        {
          Object.keys(McpOutputConfig).map(key => {
            const show = [McpOutputStatus.could, McpOutputStatus.done].includes(event[key]);
            if(!show){
              return null;
            }
            let hasDone = event[key] == McpOutputStatus.done;
            if (event[key] == McpOutputStatus.could && chatStore.manuGenAgentSet[key]) {
              hasDone = true; // 如果是手动生成的，直接认为已完成;
            }
            const config = McpOutputConfig[key];
            return (
              <div 
                key={key}
                className={`w-220px h-40px rounded-8px flex flex-shrink-0 items-center justify-center border-1px border-black text-black font-bold mr-12px mt-12px bg-white hover:bg-[#f7f7f7] ${hasDone || isAITyping ? 'text-opacity-50' : 'cursor-pointer'}`}
                onClick={
                  () => {
                    if(hasDone || isAITyping){
                      return;
                    }
                    chatStore.updateMcpEventByType(messageItem.msg_id, "convertFinalSummary", {
                      [key] : McpOutputStatus.done,
                    });
                    handleSend({ 
                      value : config.title,
                      html_message_id: messageItem.msg_id, 
                      ...config.sendParams,
                    })
                  }
                }
                >
                <SVGPureIcon className='size-16px mr-8px' name={config.icon} />
                <div className="">{config.title}</div>
              </div>
            )
          })
        }
      </div>
    </div>
  )
});
export default McpSummaryOutput;